// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1xplV","ranges":"BmiRanges_ranges__k7UEM"};